// extracted by mini-css-extract-plugin
export default {"button_link":"back-button_button_link__Wj1wL","button_icon":"back-button_button_icon__JuDH6","button_text":"back-button_button_text__t-odm"};